import React, { useState } from 'react';
import { Badge } from '../../components/ui/badge';
import { AlertTriangle, AlertOctagon, Info, ChevronDown, ChevronUp, BellRing } from 'lucide-react';

const STYLES = {
  critique: { container: 'bg-red-50 border-red-200', icon: AlertOctagon, iconColor: 'text-red-600', badge: 'bg-red-600 text-white', text: 'text-red-800' },
  attention: { container: 'bg-amber-50 border-amber-200', icon: AlertTriangle, iconColor: 'text-amber-600', badge: 'bg-amber-500 text-white', text: 'text-amber-800' },
  info: { container: 'bg-blue-50 border-blue-200', icon: Info, iconColor: 'text-blue-600', badge: 'bg-blue-500 text-white', text: 'text-blue-800' },
};

const LABELS = { critique: 'Critique', attention: 'Attention', info: 'Info' };

export const AlertesBanner = ({ alertesData }) => {
  const [expanded, setExpanded] = useState(true);
  const alertes = alertesData?.alertes || [];
  const counts = alertesData?.counts || {};

  if (alertes.length === 0) return null;

  return (
    <div className="border border-slate-200 rounded-xl bg-white shadow-sm overflow-hidden" data-testid="alertes-banner">
      <button
        type="button"
        onClick={() => setExpanded(!expanded)}
        className="w-full flex items-center justify-between px-4 py-3 hover:bg-slate-50 transition-colors"
        data-testid="alertes-toggle"
      >
        <div className="flex items-center gap-2">
          <BellRing className="w-4 h-4 text-slate-600" />
          <span className="text-sm font-semibold text-slate-800">Alertes ({alertes.length})</span>
          {counts.critique > 0 && <Badge className="bg-red-600 text-white text-[10px]">{counts.critique} critique(s)</Badge>}
          {counts.attention > 0 && <Badge className="bg-amber-500 text-white text-[10px]">{counts.attention} attention</Badge>}
          {counts.info > 0 && <Badge className="bg-blue-500 text-white text-[10px]">{counts.info} info</Badge>}
        </div>
        {expanded ? <ChevronUp className="w-4 h-4 text-slate-400" /> : <ChevronDown className="w-4 h-4 text-slate-400" />}
      </button>
      {expanded && (
        <div className="px-4 pb-4 space-y-2">
          {alertes.map((a, i) => {
            const s = STYLES[a.severite] || STYLES.info;
            const Icon = s.icon;
            return (
              <div
                key={`${a.dossier_id}-${a.type}`}
                className={`flex items-start gap-3 border rounded-lg p-3 ${s.container}`}
                data-testid={`alerte-${a.type}`}
              >
                <Icon className={`w-4 h-4 mt-0.5 shrink-0 ${s.iconColor}`} />
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2 flex-wrap">
                    <p className={`text-sm font-semibold ${s.text}`}>{a.titre}</p>
                    <Badge className={`text-[9px] ${s.badge}`}>{LABELS[a.severite]}</Badge>
                    <span className="text-[10px] text-slate-400">{a.dossier_code}</span>
                  </div>
                  <p className="text-xs text-slate-600 mt-0.5">{a.message}</p>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};
